<template>
  <div>
    <div
      v-if="false"
      class="hero-slider inner-header"
    >
      <Swiper
        :modules="[Autoplay, Pagination, EffectFade]"
        :autoplay="{ delay: 5000 }"
        :loop="true"
        effect="fade"
        pagination
        class="mySwiper"
      >
        <!-- Slide 1 - Welcome -->
        <SwiperSlide>
          <div class="slide-content slide-1">
            <h1 class="animate__animated animate__fadeInDown">
              Welcome to Petqueen
            </h1>
            <p class="animate__animated animate__fadeInUp animate__delay-1s">
              The place where pets are royalty.
            </p>
          </div>
        </SwiperSlide>

        <!-- Slide 2 - Background Image + Slogan -->
        <SwiperSlide>
          <div
            class="slide-content slide-2"
            :style="{
              backgroundImage:
                'url(https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fslider%2F3.png?alt=media)',
            }"
          >
            <div class="overlay">
              <h2 class="animate__animated animate__zoomIn">
                Find Your Furry Soulmate
              </h2>
              <p class="animate__animated animate__fadeInUp animate__delay-1s">
                From paws to hearts, we connect lives.
              </p>
            </div>
          </div>
        </SwiperSlide>

        <!-- Slide 3 - SVG + Slogan -->
        <SwiperSlide>
          <div class="slide-content slide-3">
            <svg
              viewBox="0 0 100 100"
              width="200"
              class="animated-svg"
            >
              <circle
                cx="50"
                cy="50"
                r="40"
                stroke="#ff4081"
                stroke-width="5"
                fill="none"
              />
            </svg>
            <h2 class="animate__animated animate__fadeInUp">
              Every Pet Deserves a Kingdom
            </h2>
            <p class="animate__animated animate__fadeInUp animate__delay-1s">
              Adopt. Love. Repeat.
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <!-- Hero Header -->
    <section
      v-if="false"
      class="hero-section anim-grad-box"
    >
      <div class="container inner-header">
        <h1
          ref="mainTitle"
          class="hero-title animate__animated"
        >
          Welcome to Petqueen
        </h1>
        <p
          ref="subText"
          class="hero-sub animate__animated"
        >
          Your pet's favorite platform 🐾
        </p>
        <router-link
          ref="ctaBtn"
          to="/register"
          class="cta-button animate__animated"
        >
          Join Us Now
        </router-link>
      </div>
    </section>

    <div style="margin-top: 120px">
      <SearchBar />
    </div>
    <HomeSlider />
    <HomepageFavorites />

    <section class="timer_area">
      <div class="container">
        <div>
          <div class="container py-5">
            <div
              class="position-relative"
              style="width: 100%; margin: auto"
            >
              <div class="row justify-content-center">
                <div class="col-md-6">
                  <div
                    v-for="(service, index) in services"
                    :key="index"
                    class="mb-4 d-flex justify-content-center"
                    :class="cardClass(index)"
                  >
                    <div
                      class="flip-card"
                      :class="{ flipped: flippedIndex === index }"
                      @click="toggleFlip(index)"
                    >
                      <div class="flip-card-inner">
                        <!-- FRONT -->
                        <div
                          class="flip-card-front d-flex border rounded shadow bg-white p-5 align-items-center"
                        >
                          <!-- Sol: Görsel -->
                          <div class="me-3">
                            <img
                              :src="service.image"
                              alt="icon"
                              class="store-icon"
                            >
                          </div>

                          <!-- Sağ: Başlık ve tagline -->
                          <div class="flex-grow-1">
                            <h5 class="fw-bold mb-1">
                              {{ service.title }}
                            </h5>
                            <p class="small text-muted mb-0">
                              {{ service.tagline }}
                            </p>
                          </div>
                          <div
                            class="position-absolute bottom-0 end-0 me-2 mb-2 fw-semibold small"
                            style="cursor: pointer"
                          >
                            Learn more →
                          </div>
                        </div>

                        <!-- BACK -->
                        <div
                          class="flip-card-back text-start p-3 border rounded shadow bg-light d-flex flex-column justify-content-center"
                        >
                          <h6 class="fw-bold mb-2">
                            {{ service.title }}
                          </h6>
                          <p class="small text-muted white-space-pre-line">
                            {{ service.details }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- RIGHT COLUMN (EMPTY FOR NOW) -->
                <div class="col-md-6">
                  <img
                    src="../../public/images/Banner.jpeg"
                    alt="Banner"
                    class="img-fluid"
                    style="width: 100%; height: auto; border-radius: 1rem"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="anasayfa most_product_area">
      <div class="main_box">
        <HomepagePricing />
      </div>
    </section>
    <section class="timer_area">
      <div class="container">
        <div class="main_title">
          <h2>Exclusive Hot Deal Ends Soon!.</h2>
          <p>Pet Queen still in BETA version.</p>
          <a
            class="main_btn"
            href="/register"
          >Sign In NOW</a>
        </div>
      </div>
    </section>

    <div style="height: 50px; color: white">
      .
    </div>
  </div>
</template>
<script setup>
  import 'animate.css';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import 'swiper/css';
  import 'swiper/css/effect-fade';
  import 'swiper/css/pagination';
  import { Autoplay, Pagination, EffectFade } from 'swiper/modules';
  import { ref, onMounted } from 'vue';
  import gsap from 'gsap';
  import 'animate.css';

  const flippedIndex = ref(null);

  function toggleFlip(index) {
    flippedIndex.value = flippedIndex.value === index ? null : index;
  }

  const services = [
    {
      title: 'Boarding',
      image: '/images/boarding.png',
      tagline: 'Overnight care in a sitter’s cozy home',
      details: `Your pet stays overnight at the sitter’s home — like a home-away-from-home. They’ll be treated like family, sleep indoors, and receive love, food, and attention throughout their stay.`,
    },
    {
      title: 'House Sitting',
      image: '/images/homesitting.png',
      tagline: 'Care for pets and your home',
      details: `The sitter stays at your place and takes care of your pets and home. Perfect for pets who feel safest in their own environment. Great for added home security too.`,
    },
    {
      title: 'Doggy Day Care',
      image: '/images/daycare.png',
      tagline: 'Daytime fun at the sitter’s place',
      details: `Drop your dog off in the morning and pick them up in the evening. Great for social dogs who need stimulation, or just not being alone at home during work hours.`,
    },
    {
      title: 'Dog Walking',
      image: '/images/dogwalk.png',
      tagline: 'Walks around your neighborhood',
      details: `A trusted walker comes to take your dog for a walk — perfect for busy schedules or energetic dogs who need extra outdoor time.`,
    },
    {
      title: 'Drop-In Visits',
      image: '/images/drop-in.png',
      tagline: 'Quick visits to your home',
      details: `A sitter stops by to feed, play, or clean up after your pet. Ideal for cats or independent animals who just need a check-in rather than full-time care.`,
    },
  ];

  const cardClass = (index) => {
    if (index === 2) return 'justify-content-center';
    return '';
  };
  const mainTitle = ref(null);
  const subText = ref(null);
  const ctaBtn = ref(null);

  onMounted(() => {
    if (mainTitle.value) {
      gsap.from(mainTitle.value, {
        y: -50,
        opacity: 0,
        duration: 1.2,
        ease: 'power3.out',
        delay: 0.2,
      });
    }

    if (subText.value) {
      gsap.from(subText.value, {
        y: 30,
        opacity: 0,
        duration: 1.4,
        ease: 'power3.out',
        delay: 0.8,
      });
    }

    if (ctaBtn.value) {
      gsap.from(ctaBtn.value, {
        scale: 0.5,
        opacity: 0,
        duration: 1,
        ease: 'back.out(1.7)',
        delay: 1.6,
      });
    }
  });


</script>
<script>
  /* eslint-disable */
  import SearchBar from '@/components/SearchBar.vue';
  import ChatBot from '@/components/ChatBot.vue';
  import HomeSlider from '@/components/HomeSlider.vue';
  import HomepageFavorites from '@/components/HomepageFavorites.vue';
  import HomepagePricing from '@/components/HomepagePricing.vue';

  export default {
    name: 'HomePage',

    components: {
      SearchBar,
      ChatBot,
      HomeSlider,
      HomepageFavorites,
    },
    props: {
      msg: String,
    },
    data() {
      return {
        isPrimaryBg: false,
        isSuccessBg: false,
      };
    },
    methods: {
      togglePrimaryBg() {
        this.isPrimaryBg = !this.isPrimaryBg;
        this.isSuccessBg = false;
      },
      toggleSuccessBg() {
        this.isSuccessBg = !this.isSuccessBg;
        this.isPrimaryBg = false;
      },
    },
  };
</script>

<style scoped>
  .flip-card {
    width: 100%;
    height: 150px;
    perspective: 1000px;
    cursor: pointer;
  }
  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform 0.6s;
  }
  .flip-card.flipped .flip-card-inner {
    transform: rotateY(180deg);
  }
  .flip-card-front,
  .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 1rem;
  }
  .flip-card-back {
    transform: rotateY(180deg);
  }
  .white-space-pre-line {
    white-space: pre-line;
  }
  .store-icon {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #eee;
}
</style>
<style>
  * {
    margin: 0;
    padding: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .fa {
    display: inline-block;
    font: normal normal normal 14px / 1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .home {
    min-height: 100vh;
    margin-top: 50px;
  }

  .bg-primary-light {
    background-color: rgba(13, 110, 253, 0.2) !important;
    transition: background-color 0.3s ease;
  }

  .bg-success-light {
    background-color: rgba(40, 167, 69, 0.2) !important;
    transition: background-color 0.3s ease;
  }
  .swiper-wrapper {
    height: 100vh;
  }
  .slide-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    text-align: center;
    padding: 20px;
  }
  .slide-1 {
    background: linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%);
    color: #fff;
  }
  .slide-2 {
    background-size: cover;
    background-position: center;
    position: relative;
    color: #fff;
  }
  .slide-2 .overlay {
    background: rgba(0, 0, 0, 0.5);
    padding: 40px;
    border-radius: 12px;
  }
  .slide-3 {
    background: #f1f1f1;
    color: #333;
  }
  .animated-svg {
    margin-bottom: 20px;
    animation: spin 5s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .cta-button {
    display: inline-block;
    padding: 12px 24px;
    background-color: #ff7f50;
    color: white;
    font-weight: bold;
    border-radius: 8px;
    text-decoration: none;
    transition: background-color 0.3s ease;
  }

  .cta-button:hover {
    background-color: #e0633b;
  }
  /*chat style*/
  .chat-widget-button {
    position: fixed;
    bottom: 120px;
    right: 50px;
    width: 40px;
    height: 40px;
    color: #fff;
    line-height: 40px;
    font-size: 17px;
    background: #b4000a;
    z-index: 116;
    cursor: pointer;
    border-radius: 3px;
    box-shadow: 0px 0px 0px 7px rgba(255, 255, 255, 0.2);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .chat-widget-button span {
    width: 150px;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.2);
    position: absolute;
    left: -160px;
    top: 0;
    height: 40px;
    line-height: 40px;
    background: #2c3b5a;
    color: #fff;
    border-radius: 3px;
    visibility: hidden;
    font-weight: 600;
    font-size: 12px;
    opacity: 0;
    -webkit-transition: all 0.2sease-in-out;
    transition: all 0.2sease-in-out;
    transition-behavior: normal;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
    transition-delay: 0s;
    transition-property: all;
    text-align: center;
  }
  .chat-widget-button:hover span {
    visibility: visible;
    opacity: 1;
  }
  .chat-widget_wrap {
    position: fixed;
    bottom: 180px;
    right: 50px;
    width: 300px;
    height: 400px;
    z-index: 116;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 0px 80px 0px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    display: none;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .chat-widget_header {
    height: 50px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    line-height: 50px;
    padding: 0 25px;
    background-color: #ffcbce;
  }
  .chat-widget_header h3 {
    float: left;
    color: #fff;
    font-weight: 600;
    font-size: 12px;
    line-height: 50px;
  }
  .chat-widget_header h3 a {
    color: #fff;
    text-decoration: underline;
    position: relative;
  }
  .status {
    position: absolute;
    right: 10px;
    top: 25px;
    line-height: 0;
    color: #fff;
    padding-right: 12px;
  }
  .status.st_online span {
    background: #5ecfb1;
  }
  .status span {
    position: absolute;
    right: 0;
    width: 6px;
    height: 6px;
    top: -2px;
    border-radius: 100%;
  }
  .chat-body {
    position: absolute;
    width: 100%;
    top: 50px;
    bottom: 50px;
    overflow: auto;
    left: 0;
    background: #ecf6f8;
    padding: 25px 10px;
  }
  .chat-message {
    padding-left: 60px;
    margin-bottom: 30px;
  }
  .fl-wrap {
    width: 100%;
    position: relative;
  }
  .chat-message .dashboard-message-avatar,
  .chat-message .dashboard-message-avatar img {
    width: 40px;
    height: 40px;
  }
  .chat-message .dashboard-message-avatar {
    position: absolute;
    left: 0;
    top: 20px;
  }
  .dashboard-message-avatar {
    float: left;
    width: 50px;
    height: 50px;
    overflow: hidden;
    border-radius: 100%;
  }
  .dashboard-message-avatar img {
    width: 50px;
    height: 50px;
  }
  img {
    border: 0;
    -ms-interpolation-mode: bicubic;
    vertical-align: middle;
  }
  .chat-message-user-name {
    font-size: 11px;
    color: #999;
    position: absolute;
    left: 4px;
    top: 70px;
    font-weight: 500;
  }
  .massage-date {
    float: left;
    font-size: 11px;
    color: #999;
    margin-bottom: 11px;
  }
  .massage-date span {
    position: relative;
    padding-left: 10px;
  }
  .chat-message p {
    float: left;
    padding: 6px 10px;
    background: #fff;
    border-radius: 10px;
    width: 100%;
    text-align: left;
    font-size: 11px;
    position: relative;
  }
  .chat-message.chat-message_user {
    padding-left: 0;
    padding-right: 60px;
  }
  .chat-message.chat-message_user .dashboard-message-avatar {
    left: inherit;
    right: 0;
  }
  .chat-message.chat-message_user .chat-message-user-name {
    left: inherit;
    right: 8px;
  }
  .chat-message.chat-message_user .massage-date {
    float: right;
  }
  .chat-message.chat-message_user p:before {
    content: '\f0da';
    left: inherit;
    right: -9px;
  }
  .chat-message p:before {
    font-family: Font Awesome\5 Pro;
    content: '\f0d9';
    position: absolute;
    top: 8px;
    left: -9px;
    font-size: 25px;
    color: #fff;
    font-weight: bold;
  }
  .chat-widget_input {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 20;
    height: 50px;
    padding-right: 40px;
    border-top: 1px solid #eee;
  }
  .chat-widget_input textarea {
    display: block;
    white-space: pre-wrap;
    width: 100%;
    border: none;
    background: #fff;
    font-size: 12px;
    padding: 13px 11px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    max-height: 100px;
    resize: none;
    line-height: normal;
  }
  .chat-widget_input button {
    position: absolute;
    right: 10px;
    width: 30px;
    background: none;
    border: none;
    font-size: 14px;
    top: 16px;
    z-index: 2;
    color: #fff;
    cursor: pointer;
    color: #4db7fe;
    line-height: normal;
  }
</style>
